import { createSlice } from '@reduxjs/toolkit';

interface UIState {
  // Закреплён ли сайдбар: true — раздвигает контент (256px) и держит место;
  // false — узкий рельс (72px), разворот только по наведению поверх контента.
  // Персистится (whitelist 'ui') — переживает перезагрузку.
  sidebarPinned: boolean;
}

const initialState: UIState = {
  sidebarPinned: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebarPinned: (state) => {
      state.sidebarPinned = !state.sidebarPinned;
    },
  },
});

export const { toggleSidebarPinned } = uiSlice.actions;

export const uiReducer = uiSlice.reducer;

export const selectSidebarPinned = (state: { ui: UIState }) => state.ui.sidebarPinned;
